import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setPositions } from "../../repository/slice";

function* getPositionsWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/admin/position", payload);
        if (!isError) {
            yield put(setPositions(data.rows));
        }
    } catch (error) {
        console.error("getPositionsWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getPositionsWatcher() {
    yield takeLatest("@saga/GET_POSITIONS", getPositionsWorker);
};
